import { FC } from "react";
import {
    Page,
    Text,
    View,
    Document,
    Image,
} from "@react-pdf/renderer";
import urbanicaImg from '../../../../../../assets/images/urbanica.jpeg';

import { PDFDocumentType } from "./type";
import styles from "./Styles";

const PDFDocument: FC<PDFDocumentType> = ({ complianceReport, createdBy }) => {
    const { type, name, document, search_coincidence_percentage, searched_in, compliance_list } = complianceReport;

    const tableHeaders = ["Nombres", "Apellidos", "Lista", "% Coincidencia"];
    const tableData = compliance_list
        ? compliance_list?.map(item => [
            item.first_name,
            item.last_name,
            item.list_name,
            `${item.coincidence}%`
        ])
        : [];

    const now = new Date();
    const fecha = now.toLocaleDateString("es-ES"); // Ej: 21/08/2025
    const hora = now.toLocaleTimeString("es-ES", { hour: '2-digit', minute: '2-digit', hour12: true }); // Ej: 01:00 PM

    return (
        <Document>
            <Page size="LETTER" style={styles.page} wrap>
                {/* Header */}
                <View style={styles.header} fixed>
                    <View style={styles.headerLeft}>
                        <Image src={urbanicaImg} style={styles.headerImg} />
                    </View>
                    <View style={styles.headerCenter}>
                        <Text style={styles.titleCenter}>Resultado de Búsqueda en Listas</Text>
                    </View>
                    <View style={styles.headerRight}>
                        <Text style={styles.headerRightText} >Generación del reporte</Text>
                        <Text style={styles.headerRightTextSmall}>{`El día ${fecha}`}</Text>
                        <Text style={styles.headerRightTextSmall}>{`A las ${hora}`}</Text>
                        <Text style={styles.headerRightTextSmall}>{`Por ${createdBy}`}</Text>
                    </View>
                </View>

                <View style={{ ...styles.line, marginTop: 0 }} />

                {/* Bloque de texto */}
                <View>
                    <Text style={styles.blockTitle}>Parámetros de búsqueda</Text>
                    <View style={styles.keyValueContain}>
                        <Text style={styles.key}>Tipo de persona:</Text>
                        <Text style={styles.value}>{type}</Text>
                    </View>
                    <View style={styles.keyValueContain}>
                        <Text style={styles.key}>Nombre:</Text>
                        <Text style={styles.value}>{name}</Text>
                    </View>
                    <View style={styles.keyValueContain}>
                        <Text style={styles.key}>#DOC:</Text>
                        <Text style={styles.value}>{document}</Text>
                    </View>
                    <View style={styles.keyValueContain}>
                        <Text style={styles.key}>% de coincidencia:</Text>
                        <Text style={styles.value}>{`>= ${search_coincidence_percentage}`}</Text>
                    </View>

                    <View style={{ ...styles.keyValueContain, flexDirection: "column" }}>
                        <Text style={styles.key}>Búsqueda realizada en:</Text>
                        <View style={styles.list}>
                            {searched_in?.map((searched) => (
                                <Text style={styles.listItem}>{`• ${searched}`}</Text>
                            ))}
                        </View>
                    </View>

                    <View style={styles.keyValueContain}>
                        <Text style={styles.key}>Incluye histórico de PEP</Text>
                    </View>
                </View>

                <View style={styles.line} />

                <View style={styles.keyValueContain}>
                    <Text style={styles.key}>Resultados de búsqueda</Text>
                </View>

                {/* Tabla */}
                <View style={styles.table}>
                    {/* Encabezado */}
                    <View style={styles.tableRow}>
                        {tableHeaders.map((h, i) => (
                            <Text key={i} style={styles.tableHeaderCell}>
                                {h}
                            </Text>
                        ))}
                    </View>

                    {/* Filas */}
                    {tableData?.map((row, i) => (
                        <View key={i} style={styles.tableRow} wrap>
                            {row?.map((cell, j) => (
                                <Text key={j} style={styles.tableCell} break>
                                    {cell}
                                </Text>
                            ))}
                        </View>
                    ))}
                </View>

                {/* Texto final fuera de la tabla */}
                <Text style={styles.tableFooter}>{
                    tableData.length === 1
                        ? "Se encontró 1 coincidencia."
                        : tableData.length === 0
                            ? "No se encontraron coincidencias."
                            : `Se encontraron ${tableData.length} coincidencias.
                `}</Text>


                {/* Footer */}
                <View style={styles.footerContainer} fixed>
                    <View style={{ ...styles.line, marginBottom: 4 }} />
                    <Text style={styles.footer}>El presente documento ha sido generado dentro del Sistema AML Advantage y de uso exclusivo para Dueñas Hermanos Limitada</Text>
                </View>
            </Page>
        </Document >
    )
};

export default PDFDocument;

/* 
    Componente que genera el documento PDF con los datos de compliance report

    - Daniel Bonilla Septiembre 2025
*/